import { useShallow } from 'zustand/shallow'

import { useStore, getObjectById } from '@app/store'

const useGetObjectProperty = (id, type, property) =>
  useStore(useShallow((state) => getObjectById(state, type, id)?.[property]))

export default useGetObjectProperty
